import {IAdapter} from '@drl/core/api/adapters/i-adapter';
import {ApiService} from '@drl/core/api/api.service';
import {GetListAPICommand} from '@drl/core/core.module';
import {environment} from '@drl/env/environment';

export class FetchAuditTriggerLogsCommand<T> extends GetListAPICommand<T> {
  constructor(apiService: ApiService, adapter: IAdapter<T>) {
    super(
      apiService,
      adapter,
      `${environment.patientApiUrl}/audit-trigger-logs`,
    );
  }
}
